var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconCancel = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.539 18.734 7.266 8.461A7.277 7.277 0 0 0 5.687 13 7.311 7.311 0 0 0 13 20.313c1.716 0 3.294-.591 4.539-1.579zm1.191-1.192A7.311 7.311 0 0 0 13 5.687c-1.716 0-3.294.591-4.539 1.579l10.273 10.273-.004.003zM4 13a9 9 0 1 1 18 0 9 9 0 0 1-18 0z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCancel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-cancel.5282f193.svg";
export { ForwardRef as ReactComponent };